(function () {
  var SECTION_TYPE = 'process-steps';
  var ytApiPromise = null;

  function loadYouTubeApi() {
    if (ytApiPromise) return ytApiPromise;
    ytApiPromise = new Promise(function (resolve) {
      if (window.YT && typeof window.YT.Player === 'function') {
        resolve(window.YT);
        return;
      }
      var prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function () {
        if (typeof prev === 'function') {
          try { prev(); } catch (e) {}
        }
        resolve(window.YT);
      };
      if (!document.querySelector('script[data-ps-yt], script[data-hero-lo-yt]')) {
        var tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        tag.async = true;
        tag.setAttribute('data-ps-yt', '');
        document.head.appendChild(tag);
      }
    });
    return ytApiPromise;
  }

  function mountYouTube(container) {
    var host = container.querySelector('[data-yt-host]');
    var videoId = container.dataset.youtubeId;
    var autoplay = container.dataset.autoplay !== 'false';
    if (!host || !videoId) return;

    loadYouTubeApi().then(function (YT) {
      var mount = document.createElement('div');
      host.innerHTML = '';
      host.appendChild(mount);

      new YT.Player(mount, {
        videoId: videoId,
        host: 'https://www.youtube-nocookie.com',
        playerVars: {
          autoplay: autoplay ? 1 : 0,
          mute: autoplay ? 1 : 0,
          loop: autoplay ? 1 : 0,
          playlist: autoplay ? videoId : undefined,
          controls: autoplay ? 0 : 1,
          modestbranding: 1,
          rel: 0,
          iv_load_policy: 3,
          playsinline: 1,
          disablekb: autoplay ? 1 : 0,
          fs: autoplay ? 0 : 1
        },
        events: {
          onReady: function (event) {
            try {
              if (autoplay) {
                event.target.mute();
                event.target.playVideo();
              }
            } catch (e) {}
            var video = container.querySelector('[data-process-video]');
            if (video) video.setAttribute('data-poster-hidden', 'true');
          }
        }
      });
    });
  }

  function mountVimeo(container) {
    var host = container.querySelector('[data-vimeo-host]');
    var videoId = container.dataset.vimeoId;
    var autoplay = container.dataset.autoplay !== 'false';
    if (!host || !videoId) return;

    var params = [
      autoplay ? 'autoplay=1' : 'autoplay=0',
      autoplay ? 'muted=1' : 'muted=0',
      autoplay ? 'loop=1' : 'loop=0',
      autoplay ? 'background=1' : '',
      'playsinline=1',
      'dnt=1'
    ].filter(Boolean).join('&');

    var iframe = document.createElement('iframe');
    iframe.src = 'https://player.vimeo.com/video/' + videoId + '?' + params;
    iframe.allow = 'autoplay; fullscreen; picture-in-picture';
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('loading', 'lazy');
    iframe.title = 'Video';
    host.innerHTML = '';
    host.appendChild(iframe);

    iframe.addEventListener('load', function () {
      var video = container.querySelector('[data-process-video]');
      if (video) video.setAttribute('data-poster-hidden', 'true');
    });
  }

  function setupActiveStep(container) {
    var list = container.querySelector('[data-process-list]');
    if (!list) return null;
    var steps = list.querySelectorAll('[data-process-step]');
    if (!steps.length) return null;

    function setActive(target) {
      steps.forEach(function (step) {
        step.classList.toggle('is-active', step === target);
      });
    }

    if (!('IntersectionObserver' in window)) {
      // Fallback: leave first step active.
      return null;
    }

    var observer = new IntersectionObserver(function (entries) {
      // Pick the entry closest to the activation line (~45% from top).
      var best = null;
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        if (!best || entry.intersectionRatio > best.intersectionRatio) {
          best = entry;
        }
      });
      if (best) setActive(best.target);
    }, {
      // Activation band sits roughly mid-viewport.
      rootMargin: '-45% 0px -45% 0px',
      threshold: [0, 0.25, 0.5, 0.75, 1]
    });

    steps.forEach(function (step) { observer.observe(step); });

    return {
      destroy: function () { observer.disconnect(); }
    };
  }

  function init(container) {
    if (!container || container.dataset.psBound === 'true') return;
    container.dataset.psBound = 'true';

    var mode = container.dataset.videoMode;
    if (mode === 'youtube') {
      mountYouTube(container);
    } else if (mode === 'vimeo') {
      mountVimeo(container);
    } else if (mode === 'file' || mode === 'external') {
      var video = container.querySelector('[data-process-video]');
      if (video) video.setAttribute('data-poster-hidden', 'true');
    }

    var stepWatcher = setupActiveStep(container);
    container._psCleanup = function () {
      if (stepWatcher && typeof stepWatcher.destroy === 'function') stepWatcher.destroy();
    };
  }

  function destroy(container) {
    if (!container) return;
    if (typeof container._psCleanup === 'function') container._psCleanup();
    container.dataset.psBound = '';
  }

  function bootstrap(root) {
    (root || document).querySelectorAll('[data-section-type="' + SECTION_TYPE + '"]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootstrap(); });
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', function (e) { bootstrap(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-section-type="' + SECTION_TYPE + '"]').forEach(destroy);
  });
  document.addEventListener('shopify:section:select', function (e) { bootstrap(e.target); });
})();
